var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spellcasting fade-in"},_vm._l((_vm.getActiveClasses),function(magicClass,index){return _c('div',{key:index},[(_vm.isSpellcastingClass(magicClass) && _vm.hasClassSpells(magicClass))?_c('ClassSpellManager',{key:index,attrs:{"magicClass":magicClass}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }